<p-drawer id="popout-link" [visible]="visible()" (visibleChange)="visible.set($event)" position="right" [dismissible]="false" (onHide)="close()"
    styleClass="w-full xl:w-9/12! shared-popout main-drawer" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" [header]="header">
    <ng-container #container class="h-full"></ng-container>
</p-drawer>